/* @ngInject */
function ChangeBoardsController ($scope, $location, $timeout, BoardsService, ViewOptionService) {
  $scope.boards = []

  const api = {
    activate,
    _getBoards
  }
  this.getApi = () => api
  activate()

  function activate () {
    api._getBoards()
  }

  $scope.changeBoard = function (board) {
    const boardIdToUrl = board.id
    const url = $location.search()

    let viewOption = ViewOptionService.get(board.id)

    if (url.term) {
      viewOption = ViewOptionService.getSearchView()
    }

    $location.path(`/workflow/${viewOption}`).search({ ...url, board: boardIdToUrl })
    $timeout(() => {
      location.reload()
    }, 0)
  }

  function _getBoards () {
    return BoardsService.getBoards().then(result => {
      $scope.boards = result.rows
    })
  }
}

export { ChangeBoardsController }
